<template>
  <v-col class="register default-slot" md="7" sm="12">
    <add-lessee-modal
      :changeLesseeInfo="changeLesseeInfo"
      :lesseeDialog="lesseeDialog"
      :toggleLesseeModal="toggleLesseeModal"
      :lesseeInfo="lesseeInfo"
    />
    <v-dialog max-width="500px" v-model="rulesDialog">
      <v-card class="search-modal">
        <h2>Rules</h2>
        <ol class="text-left">
          <li>All lessee memberships must be current.</li>
          <li>
            Owners of a dog must also be listed as lessees if they wish to be
            litter owners as a lease overrides ownership on litters during the
            lease period.
          </li>
          <li>
            Do not submit a Litter Application until you are notified that the
            Lease is complete.
          </li>
          <li>
            The primary lessee will be responsible for submitting the litter
            application with payment as well as registering and releasing
            puppies.
          </li>
          <li>
            All sires and dams must be DNA profiled prior to the registration of
            their first litter. You may submit your litter while DNA is pending
            and it will be approved once results are on file with ASCA.
          </li>
        </ol>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <router-link class="back-icon" to="/">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back to home
      </router-link>
    </div>
    <h1 class="register-title">Lease Agreement</h1>
    <p class="mt-3"><a v-on:click="toggleRules()">View rules</a> <br /></p>
    <v-row justify="center">
      <v-tooltip bottom content-class="fee-table-tooltip">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">View pricing table</span>
        </template>
        <simple-fee-table :priceInfo="priceInfo" />
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="text-left">
        <h2>Leased Aussie</h2>
        <p>
          <b>Name: </b> {{ dogInfo.name }} <br />
          <b>ASCA ID: </b> {{ dogInfo.dogId }} <br />
          <b>Main Color: </b> {{ dogInfo.body }} <br />
          <b>DNA Status: </b> {{ dogInfo.dnaStatus }} <br />
          <v-divider></v-divider>
          <CoownersList :owners="dogInfo.owners" :ownershipType="dogOwnershipType" />
        </p>
      </v-col>
      <v-col>
        <div>
          <h2>
            Lessee(s)&nbsp;&nbsp;<a
              v-if="lesseeInfo.length"
              v-on:click="toggleLesseeModal()"
              >Edit</a
            >
          </h2>
          <div v-if="lesseeInfo.length">
            <v-radio-group v-model="primaryLessee" @change="changePrimaryLessee">
              <span v-for="co in lesseeInfo" :key="co.personId">
                <span>
                  <v-layout align-start row class="mb-3">
                    <v-radio
                      color="primary"
                      :label="`${co.firstName} ${co.lastName} (Member: ${co.memberId}) `"
                      :value="co.personId"
                    >
                      <template v-slot:label
                        ><span v-if="co.isPrimary">
                          <v-tooltip dark right>
                            <template v-slot:activator="{ on, attrs }">
                              <font-awesome-icon
                                icon="paw"
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                              />&nbsp;
                            </template>
                            <span>
                              &nbsp;"Only the primary lessee can register litters, release and register puppies. They will also be a primary contact person for the ASCA office."
                            </span>
                          </v-tooltip>
                        </span>
                        <span v-else>
                          <font-awesome-icon icon="paw" color="transparent" />&nbsp;
                        </span>
                        {{ co.firstName }}
                        {{ co.lastName }}
                        <span v-if="co.memberId"
                          >(Member: {{ co.memberId.trim() }})</span
                        >
                        <br />
                      </template>
                    </v-radio>
                  </v-layout>
                </span>
              </span>
            </v-radio-group>
          </div>
          <div v-else>
            <a v-on:click="toggleLesseeModal()">
              <font-awesome-icon icon="plus" />
              Add lessee
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-btn
      class="white--text"
      large
      v-on:click="changePage(2)"
      :disabled="!dogInfo.dogId || !lesseeInfo.length"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>1</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import FooterText from "@/components/common/FooterText.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import AddLesseeModal from "@/components/common/AddLesseeModal.vue";

export default Vue.extend({
  components: { AddLesseeModal, SimpleFeeTable, FooterText, CoownersList },
  name: "LeaseRequestForm1",
  data: function () {
    return {
      rulesDialog: false,
      lesseeDialog: false,
    };
  },
  computed: {
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
    leaseOwnershipType: function() {
      return OwnershipType.Lease;
    },
  },
  methods: {
    toggleRules: function () {
      this.$data.rulesDialog = !this.$data.rulesDialog;
    },
    toggleLesseeModal: function () {
      this.$data.lesseeDialog = !this.$data.lesseeDialog;
    },
  },
  props: {
    dogInfo: Object,
    changePage: Function,
    lesseeInfo: Array,
    changeLesseeInfo: Function,
    priceInfo: Object,
    primaryLessee: Number,
    changePrimaryLessee: Function,
  },
});
</script>
